import { DESKTOP_SPACING, FONT_SIZE, NATURAL } from "@/theme";
import { Heading, PageHeader, Typo } from "@/components/atoms";
import { useCallback, useEffect, useState } from "react";

import { PackageList } from "@/components/pages";
import { useApi } from "@/api";
import { useNavigate } from "react-router-dom";

const PackagesView = () => {

  const { customer, orderTemplate, session } = useApi();

  const [branchId, setbranchId] = useState<string | null>(null);
  const [loadingOrderTemplates, setLoadingOrderTemplates] = useState(false);
  const navigate = useNavigate();
  
  
  const getOrderTemplates = async (customerId: string) => {
    setLoadingOrderTemplates(true);
    const branches = await customer.getBranches(customerId);
    setbranchId(branches[0].BranchId.toString());
    orderTemplate.getList([branches[0]]);
    setLoadingOrderTemplates(false);
  }

    useEffect(() => {
        getOrderTemplates(session.user?.id || '');
    }, []);

    const handleSelectOrderTemplate = useCallback((orderTypeId: number) => {
        navigate(`/order-new/brid=${branchId}/pkgid=${orderTypeId}`);
    }, [branchId]);

  return (<>
        <PageHeader>
          <Heading scale="h1" fontColor={NATURAL.K} margin={`0 0 ${DESKTOP_SPACING.SM}px`}>Select Package</Heading>
          <Typo fontColor={NATURAL.G} fontSize={FONT_SIZE.SM}>Please select appropriate package of services for your new order.</Typo>
        </PageHeader>
          <PackageList
            isAdmin={false}
            loadingOrderTemplates={loadingOrderTemplates}
            onSelectOrderTemplate={handleSelectOrderTemplate}
            orderTemplates={orderTemplate.orderTemplates}
            useSimpleSelect={true}
          />
      </>
  );
}

export default PackagesView;